module.exports = __webpack_public_path__ + "img/four.1542719f.png";